import loop54 from '~/lib/api/loop54';
import { Loop54Types } from '~/lib/data-contract';
import { getUrl } from '~/services/loop54/utils';

export default function getBasketRecommendations(
    signal: AbortSignal | undefined,
    params: Loop54Types.GetBasketRecommendationsRequest,
) {
    return loop54
        .post(getUrl('/getBasketRecommendations'), {
            json: params,
            signal,
        })
        .json<Loop54Types.GetBasketRecommendationsResponse>();
}
